<template>
    <div class="min-h-screen w-full bg-stone-100">
        <header class="sticky top-0 z-40 w-full bg-white shadow">
            <div class="border-b border-gray-300 py-3 px-6">
                <nav class="relative flex items-center">
                    <div class="flex items-center">
                        <a href="https://www.montgomerycountymd.gov/green/energy/benchmarking.html" target="_blank">
                            <span class="sr-only">Montgomery County Building Lookup Tool</span>
                            <img class="h-10" src="../assets/images/montgomery-logo.png" alt="Montgomery County Building Energy Benchmarking Program Logo">
                        </a>
                    </div>
                    <div class="text-xs font-medium flex-1 flex items-center justify-end space-x-1">
                        <router-link to="/" class="py-1 px-2 text-primary hover:bg-primary hover:bg-opacity-10 rounded">
                            Search Buildings
                        </router-link>
                        <router-link to="/building-inventory" class="py-1 px-2 text-primary hover:bg-primary hover:bg-opacity-10 rounded">
                            DEP Building Inventory
                        </router-link>
                        <anchor-tag class="ml-auto py-1 px-2 text-primary" href="mailto:energy@montgomerycountymd.gov">
                            <span class="sr-only">Help: Contact Us</span>
                            <help-icon class="h-5 w-5 text-primary" />
                        </anchor-tag>
                    </div>
                </nav>
            </div>
        </header>
        <main class="flex flex-1 pt-6 px-4">
            <slot />
        </main>
        <footer-bar />
    </div>
</template>
<script>
import { HelpIcon } from '@touchstone/touchstone-assets';
import FooterBar from './FooterBar';
import { RouterLink } from 'vue-router';

export default {
    components: {
        FooterBar,
        HelpIcon,
        RouterLink,
    }
};
</script>
